import {MarkerClusterer} from "@googlemaps/markerclusterer";

export async function initMap(markerData) {
  // The location of Uluru
  const delhi = {lat: 28.6139, lng: 77.209};

  let position;
  if (markerData && markerData.length) {
    position = markerData[0].position;
  } else position = delhi;
  // Request needed libraries.
  //@ts-ignore
  const {Map} = await google.maps.importLibrary("maps");
  let bounds = new google.maps.LatLngBounds();
  markerData.forEach((marker) => {
    var googleMarker = new google.maps.LatLng(
      marker?.position?.lat,
      marker?.position?.lng,
    );
    bounds.extend(googleMarker);
  });

  // The map, centered at Uluru
  const map = new Map(document.getElementById("map-container"), {
    zoom: 18,
    center: position,
    mapId: "DEMO_MAP_ID",
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
  });

  // Fit the map to the bounds
  if (markerData.length > 1) {
    map.fitBounds(bounds);
  }

  if (markerData.length == 0) {
    map.setZoom(5);
  }
console.log(markerData);
  const markers = markerData.map(
    (marker) =>
      new google.maps.Marker({
        position: marker.position,
        // label: marker.label,
        icon: marker.icon,
      }),
  );

  // Add a marker clusterer to manage the markers.
  new MarkerClusterer({markers, map});
}
